import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastPosition, ToastService } from '../services/toast.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { AuthService } from '../authentication/auth.service';
import * as Sentry from "@sentry/angular";


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(
        private toastService: ToastService,
        private authenticationService: AuthService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req)
            .pipe(catchError((error) => {
                if (error.status === 401) {
                    //Sentry.captureMessage(`401 Unauthorized: ${req.url}`, {
                    //    level: 'warning',
                    //    extra: {
                    //        url: req.url,
                    //        method: req.method,
                    //        body: req.body,
                    //        status: error.status,
                    //        error: error.error,
                    //        headers: req.headers.keys().reduce((acc, key) => {
                    //            acc[key] = req.headers.get(key);
                    //            return acc;
                    //        }, {} as Record<string, string | null>)
                    //    },
                    //});

                    this.authenticationService.logout(false);
                    this.showLoggedOutErrorToast();
                    return EMPTY;
                } else {
                    // FirebaseCrashlytics.recordException({
                    //     message: `Http Call Error ${req.url}: \n
                    //     Request Body: ${JSON.stringify(req.body, null, 2)}\n
                    //     Error Code: ${error.status}\n
                    //     Error: ${JSON.stringify(error, null, 2)}`
                    // })
                    return throwError(() => new Error(JSON.stringify(error, null, 2)));
                }
            }))
    }

    private async showLoggedOutErrorToast(): Promise<void> {
        await this.toastService.showErrorToast('Je bent afgemeld', ToastPosition.Top);
    }
}
